import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-app-dashboard',
  templateUrl: './app-dashboard.component.html',
  styleUrls: ['./app-dashboard.component.scss']
})
export class AppDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
